var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect } from 'react';
import { ensureMediaPermissions } from '../../src/utils';
import { useSafePromise } from '@alucio/lux-ui';
export function useDevices() {
    const [devices, setDevices] = useState([]);
    const safePromise = useSafePromise();
    useEffect(() => {
        const getDevices = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield safePromise.makeSafe(ensureMediaPermissions());
                const devices = yield safePromise.makeSafe(navigator.mediaDevices.enumerateDevices());
                setDevices(devices);
            }
            catch (err) {
                if (!err.isCanceled)
                    throw err;
            }
        });
        navigator.mediaDevices.addEventListener('devicechange', getDevices);
        getDevices();
        return () => {
            navigator.mediaDevices.removeEventListener('devicechange', getDevices);
        };
    }, []);
    return devices;
}
export function useAudioInputDevices() {
    const devices = useDevices();
    return devices.filter(device => device.kind === 'audioinput');
}
export function useVideoInputDevices() {
    const devices = useDevices();
    return devices.filter(device => device.kind === 'videoinput');
}
export function useAudioOutputDevices() {
    const devices = useDevices();
    return devices.filter(device => device.kind === 'audiooutput');
}
export function hasAudioInputDevices() {
    const devices = useDevices();
    return devices.filter(device => device.kind === 'audioinput').length > 0;
}
export function hasVideoInputDevices() {
    const devices = useDevices();
    return devices.filter(device => device.kind === 'videoinput').length > 0;
}
//# sourceMappingURL=deviceHooks.js.map